/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Import_Unknown_List_NameInputs */

const en_work_order_import_unknown_list_name = /** @type {(inputs: Work_Order_Import_Unknown_List_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown`)
};

const fr_work_order_import_unknown_list_name = /** @type {(inputs: Work_Order_Import_Unknown_List_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inconnu`)
};

const de_work_order_import_unknown_list_name = /** @type {(inputs: Work_Order_Import_Unknown_List_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unbekannt`)
};

const it_work_order_import_unknown_list_name = /** @type {(inputs: Work_Order_Import_Unknown_List_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sconosciuto`)
};

const ru_work_order_import_unknown_list_name = /** @type {(inputs: Work_Order_Import_Unknown_List_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неизвестный`)
};

const es_work_order_import_unknown_list_name = /** @type {(inputs: Work_Order_Import_Unknown_List_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconocido`)
};

const zh_cn2_work_order_import_unknown_list_name = /** @type {(inputs: Work_Order_Import_Unknown_List_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知`)
};

const ja_work_order_import_unknown_list_name = /** @type {(inputs: Work_Order_Import_Unknown_List_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知`)
};

const hi_work_order_import_unknown_list_name = /** @type {(inputs: Work_Order_Import_Unknown_List_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अज्ञात`)
};

const pt_pt2_work_order_import_unknown_list_name = /** @type {(inputs: Work_Order_Import_Unknown_List_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desconhecido`)
};

/**
* | output |
* | --- |
* | "Unknown" |
*
* @param {Work_Order_Import_Unknown_List_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_unknown_list_name = /** @type {((inputs?: Work_Order_Import_Unknown_List_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_Unknown_List_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_import_unknown_list_name(inputs)
	if (locale === "de") return de_work_order_import_unknown_list_name(inputs)
	if (locale === "it") return it_work_order_import_unknown_list_name(inputs)
	if (locale === "ru") return ru_work_order_import_unknown_list_name(inputs)
	if (locale === "es") return es_work_order_import_unknown_list_name(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_import_unknown_list_name(inputs)
	if (locale === "ja") return ja_work_order_import_unknown_list_name(inputs)
	if (locale === "hi") return hi_work_order_import_unknown_list_name(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_import_unknown_list_name(inputs)
	return en_work_order_import_unknown_list_name(inputs)
});